import { render } from "./ShowFile.vue?vue&type=template&id=13364ec4&scoped=true"
import script from "./ShowFile.vue?vue&type=script&lang=js"
export * from "./ShowFile.vue?vue&type=script&lang=js"

import "./ShowFile.vue?vue&type=style&index=0&id=13364ec4&scoped=true&lang=css"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13364ec4"]])

export default __exports__